import Vue from 'vue';
import Snotify, { SnotifyPosition } from 'vue-snotify';

import "../assets/css/snotify.css";

const options = {
    toast: {
        position: SnotifyPosition.rightBottom
    }
};

Vue.use(Snotify, options);